import React from 'react'
import { Router } from '@reach/router'
import Layout from './layout'
import DecodeApiDownloadSchema from '../components/internal/decode-api-download-schema'
import InternalRoute from '../components/internal/InternalRoute'

const Internal = () => {
  return (
    <Layout>
      <Router basepath="/internal">
        <InternalRoute
          path="/decode-api-download-schema"
          component={DecodeApiDownloadSchema}
        />
      </Router>
    </Layout>
  )
}

export default Internal
